module.exports = __webpack_public_path__ + "img/diagram.60b095dd.png";